/**
 * Where a signed-in user lands: the owner has the dashboard, crew their schedule, an estimator their own quotes, and Office (`staff`) the quotes list
 * (decision 27: quote-first, Office = "Quotes, invoices and clients").
 */
export function homePathForRole(role: string | undefined): string {
  if (role === 'admin') return '/admin/dashboard';
  if (role === 'staff') return '/admin/quotes';
  if (role === 'crew') return '/crew';
  if (role === 'estimator') return '/admin/quotes';
  return '/';
}

/** The translation key of a role's display name (Owner, Office, Crew, Estimator), from the `team` namespace's badges. */
export function roleLabelKey(role: string): string {
  return `team:badges.${role}`;
}

/** Where the "Dashboard" link of the marketing pages goes for a signed-in user: their own home (customers keep the owner dashboard link they always had). */
export function dashboardPathForRole(role: string | undefined): string {
  return role === 'customer' || role === undefined ? '/admin/dashboard' : homePathForRole(role);
}

/** The `team:toasts.*` key that names a role in "X is now ...". */
export function roleToastKey(role: string): string {
  if (role === 'admin') return 'toasts.roleAdmin';
  if (role === 'crew') return 'toasts.roleCrew';
  if (role === 'estimator') return 'toasts.roleEstimator';
  return 'toasts.roleStaff';
}
